import {HTTP_REST_URLS} from "../config/urls";
import { useApiMiddleware } from "./useApiMiddleware";

export const useCategoryData = () => new Promise((resolve, reject) => {
    
    const url = HTTP_REST_URLS.GET_CATEGORY;

    fetch(url, {
        method: 'GET'
    })
        .then((res) => (res.json()))
        .then(async(response) => {
            const resultValue = await useApiMiddleware(response)  

            if(!resultValue.error)
            {
                resolve(resultValue)                
            }

        })
})
